import { render, staticRenderFns } from "./m-footer.vue?vue&type=template&id=31b3ab03&scoped=true"
import script from "./m-footer.vue?vue&type=script&lang=js"
export * from "./m-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b3ab03",
  null
  
)

export default component.exports